<template functional>
  <svg class="icon-clock" xmlns="http://www.w3.org/2000/svg" :width="props.size" :height="props.size" viewBox="0 0 24 24" fill="none" stroke="#7b8190" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
</template>

<script>
export default {
  name: 'IconClock',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>

<style>
/* vue2-datepicker applies `.mx-datepicker svg { fill: currentColor; width: 1em; height: 1em; }`
   globally, which overrides this icon's outline styling when used as its icon-calendar slot. */
svg.icon-clock {
  fill: none !important;
}
</style>
